<ng-container *ngIf="serverError">
  <div class="modal-header">
    <h4 class="modal-title">Server Error: {{ serverError }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</ng-container>

<ng-container *ngIf="!serverError">

  <div class="modal-header">
    <h4 class="modal-title">Set Deposit Account</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <h3 *ngIf="loadingAccounts" class="text-secondary">Loading accounts...</h3>

    <ng-container *ngIf="!loadingAccounts">
      <p>Select which Quickbooks account will be used as the deposit account:</p>

      <p *ngIf="accounts.length === 0">No Quickbooks accounts found</p>

      <div class="form-check" *ngFor="let account of accounts">
        <input class="form-check-input" type="radio" name="selectedAccount"
               id="selectedAccount{{ account.account_id }}"
               [value]="account" [(ngModel)]="selectedAccount">
        <label class="form-check-label" for="selectedAccount{{ account.account_id }}">
          {{ account.account_name }} ({{ account.account_type }})
        </label>
      </div>
    </ng-container>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary"
            (click)="activeModal.close()">
      Cancel
    </button>
    <button class="btn btn-primary"
            (click)="handleSubmit()"
            [disabled]="selectedAccount === null"
            [class.disabled]="selectedAccount === null"
            *ngIf="!loadingSave">
      Save
    </button>
    <button class="btn btn-primary disabled" type="button" disabled
            *ngIf="loadingSave">
      Loading...
    </button>
  </div>

</ng-container>
